<template>
  <div>
    <BreadCrumb class="bread" :breads="['商品管理','模板管理',title]"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">{{title}}</span>
        <router-link :to="{path:'/index/shoppingModel'}">
          <el-button class="addCustom" size="small" icon="el-icon-arrow-left">
            返回列表
          </el-button>
        </router-link>
      </div>
    </div>
    <el-form ref="form" size="small" class="form-container" label-width="120px" :rules="rules" :model="formData">
      <div class="form-container__left">
        <el-form-item label="产品型号" prop="terminal_type_name">
          <el-input v-model="formData.terminal_type_name" @focus="openSimpleFindDialog" readonly></el-input>
        </el-form-item>
        <el-form-item label="层数">
          <el-input v-model="formData.terminal_rows" disabled></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="formData.created_at" disabled></el-input>
        </el-form-item>
      </div>
      <div class="form-container__right">
        <el-form-item label="模板名称" prop="template_name">
          <el-input v-model="formData.template_name" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="列数">
          <el-input v-model="formData.terminal_column" disabled></el-input>
        </el-form-item>
        <el-form-item label="总商品数" prop="">
          <el-input v-model="count" disabled></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="table-con">
      <div class="table-con__header">
        <span class="table-con__header-title">商品信息</span>
        <div class="table-con__header-operate">
          <el-button class="table-con__header-button" size="small" @click="openSelectRowDialog" :disabled="formData.terminal_type_name === ''">新增</el-button>
        </div>
      </div>
      <el-table :data="formData.items_list" :row-class-name="tableRowClassName">
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="goods_lane" label="货道编号" align="center">
          <div slot-scope="scope">
            <span v-if="mode === 'VR'">{{scope.row.goods_lane.split('-')[0]}}层{{scope.row.goods_lane.split('-')[1]}}列</span>
            <span v-if="mode === 'GR' || mode === 'GVR'">{{scope.row.goods_lane.split('-')[0]}}层</span>
          </div>
        </el-table-column>
        <el-table-column prop="item_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="category_name" label="分类" align="center">
        </el-table-column>
        <el-table-column prop="item_number" label="商品编码" align="center">
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.image_url" alt="" width="80px" height="80px">
          </template>
        </el-table-column>
        <el-table-column label="商品重量(g)" align="center">
          <template slot-scope="scope">
            {{scope.row.min_weight}} ~ {{scope.row.max_weight}}
          </template>
        </el-table-column>
        <el-table-column label="可放数量" align="center">
          <div slot-scope="scope">
            <el-input v-model="scope.row.qty" size="small" class="table-con__input" @change="validateQty(scope.row,scope.$index)" maxlength="2"></el-input>
            <div class="table-error">{{scope.row.qty_error}}</div>
          </div>
        </el-table-column>
        <el-table-column label="预警数量" align="center">
          <div slot-scope="scope">
            <el-input v-model="scope.row.warn_qty" @change="validateQty(scope.row,scope.$index)" size="small" class="table-con__input" maxlength="2"></el-input>
          </div>
        </el-table-column>
        <el-table-column label="成本(元)" align="center">
          <div slot-scope="scope">
            <el-input v-model="scope.row.cost_price" size="small" class="table-con__input" @change="validatePrice(scope.row,scope.$index)" maxlength="8"></el-input>
            <div class="table-error">{{scope.row.price_error}}</div>
          </div>
        </el-table-column>
        <el-table-column label="售价(元)" align="center">
          <div slot-scope="scope">
            <el-input v-model="scope.row.real_price" size="small" class="table-con__input" @change="validatePrice(scope.row,scope.$index)" maxlength="8"></el-input>
          </div>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180px">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="openSelectGoods(scope.row)">选择</el-button>
            <el-button type="danger" size="small" @click="deleteRow(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="submit-container">
      <el-button type="warning" @click="addNext" v-if="!$route.query.id">提交并继续添加</el-button>
      <el-button type="primary" @click="add">提交</el-button>
      <el-button @click="reset" v-if="!$route.query.id">重置</el-button>
      <el-button @click="goBack" v-if="$route.query.id">取消</el-button>
    </div>
    <simple-find-dialog :dialogData="dialogData" :show="dialogShow" width="500px" @close="closeSimpleFindDialog"></simple-find-dialog>
    <select-goods-dialog v-if="mode" :show="selectGoodsVisible" @close="closeSelectGoodsDialog" :mode="mode"></select-goods-dialog>
    <el-dialog :visible.sync="rowAndColDialog" title="新增" width="400px">
      <el-form size="small" :inline="true">
        <el-form-item label="行号">
          <el-input-number v-model="row" controls-position="right" :min="1" :max="formData.terminal_rows"></el-input-number>
        </el-form-item>
        <el-form-item label="列号">
          <el-input-number v-model="col" controls-position="right" :min="1" :max="formData.terminal_column"></el-input-number>
        </el-form-item>
        <span v-show="isEmploy" class="dialog-tip">所选的货道已被占用，请重新选择</span>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="primary" @click="addOneWay">确定</el-button>
        <el-button size="small" @click="rowAndColDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SimpleFindDialog from "@/components/SimpleFindDialog";
import SelectGoodsDialog from "@/components/SelectGoodsDialog";
import apis from "@/config/apis/index";
import { deepClone, dateFormat } from "@/plugins/util";
import { isW, isNumber, validate_decimal } from "@/plugins/common";
export default {
  data() {
    return {
      rules: {
        terminal_type_name: {
          required: true,
          message: "请选择产品型号"
        },
        template_name: [
          {
            required: true,
            message: "请输入中文或者字母，最大30个字符"
          },
          {
            validator: function(rule, value, callback) {
              if (!isW(value)) {
                return callback(new Error("请输入中文或者字母，最大30个字符"));
              } else {
                return callback();
              }
            }
          }
        ]
      },
      formData: {
        terminal_type_name: "",
        items_list: []
      },
      dialogData: {
        searchItems: [
          {
            key: "name",
            label: "产品型号"
          }
        ],
        searchTableItem: [
          {
            key: "name",
            name: "产品型号"
          }
        ],
        proxyLink: "category_list_by_contract",
        proxyType: "get"
      },
      dialogShow: false,
      row: 0,
      col: 0,
      mode: "",
      isEmploy: false,
      selectGoodsVisible: false,
      rowAndColDialog: false,
      createTime: ""
    };
  },
  components: {
    BreadCrumb,
    SimpleFindDialog,
    SelectGoodsDialog
  },
  computed: {
    title() {
      if (this.$route.query.id) {
        return "修改模板";
      } else {
        return "新增模板";
      }
    },
    count() {
      let count = 0;
      this.formData.items_list.forEach(item => {
        if (item.item_id) {
          count++;
        }
      });
      return count;
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id);
    } else {
      this.formData.created_at = dateFormat("yyyy-MM-dd hh:mm:ss", new Date());
    }
  },
  methods: {
    getData(id) {
      this.$axios
        .get(apis.template_detail, {
          params: {
            id: id
          }
        })
        .then(res => {
          this.formData = res.data.data;
          this.mode = res.data.data.mode;
        });
    },
    openSimpleFindDialog() {
      this.dialogShow = true;
    },
    closeSimpleFindDialog(data) {
      if (data) {
        this.formData.items_list = [];
        this.$set(this.formData, "terminal_type_name", data.name);
        this.$set(this.formData, "terminal_type_id", data.id);
        this.formData.terminal_rows = data.rows;
        this.formData.terminal_column = data.column;
        this.mode = data.mode;
        for (let r = 1; r <= this.formData.terminal_rows; r++) {
          for (let c = 1; c <= this.formData.terminal_column; c++) {
            this.formData.items_list.push(this.createRow(r, c));
          }
        }
      }
      this.dialogShow = false;
    },
    //打开选择行列
    openSelectRowDialog() {
      this.rowAndColDialog = true;
      this.isEmploy = false;
    },
    createRow(row, col) {
      return {
        category_name: "",
        column: col,
        cost_price: 0,
        goods_lane: row + "-" + col,
        image_url: "",
        item_id: "",
        item_name: "",
        item_number: "",
        max_weight: "",
        min_weight: "",
        qty: 10,
        real_price: 0,
        rows: row,
        warn_qty: 2
      };
    },
    //删除货道
    deleteRow(scope) {
      this.formData.items_list.splice(scope.$index, 1);
    },
    //增加单货道
    addOneWay() {
      let count = 0;
      let _index = null;
      this.formData.items_list.forEach((item, index) => {
        let nowRow = +item.goods_lane.split("-")[0];
        let nowCol = +item.goods_lane.split("-")[1];
        let goods_lane = this.row + "-" + this.col;
        //检定是否重复
        if (this.col === nowCol && this.row === nowRow) {
          count++;
        }
        //检定插入列
        if (goods_lane < item.goods_lane && _index === null) {
          _index = index;
        } else if (
          _index === null &&
          index === this.formData.items_list.length - 1
        ) {
          _index = index + 1;
        }
      });
      this.isEmploy = count > 0;
      if (count > 0) {
        return;
      } else {
        this.formData.items_list.splice(
          _index,
          0,
          this.createRow(this.row, this.col)
        );
        this.rowAndColDialog = false;
      }
    },
    //打开选择商品
    openSelectGoods(data) {
      this.selectGoodsVisible = true;
      this.selectRow = data;
    },
    //关闭选择商品
    closeSelectGoodsDialog(data) {
      if (data.id) {
        let GRlist = [];
        let _item = null;
        let _index = null;
        this.formData.items_list.forEach((item, index) => {
          if (this.mode === "GR") {
            //是否同层且不同列
            if (this.selectRow.rows === item.rows && item.item_id) {
              GRlist.push(item);
            }
          }
          if (this.selectRow.goods_lane === item.goods_lane) {
            _item = {
              category_name: data.category_name,
              column: item.column,
              cost_price: data.cost_price,
              goods_lane: item.goods_lane,
              id: item.id,
              image_url: data.image_url,
              item_id: data.id,
              item_name: data.name,
              item_number: data.number,
              max_weight: data.max_weight,
              min_weight: data.min_weight,
              qty: 10,
              real_price: data.real_price,
              rows: item.rows,
              warn_qty: 2
            };
            _index = index;
          }
        });
        //判断哪层货道有同一类商品
        let eqList = [];
        this.formData.items_list.forEach((item, index) => {
          if (_item.item_id === item.item_id && _item.rows === item.rows) {
            eqList.push(item);
          }
        });
        if (eqList.length > 0) {
          alert
            .alert("您选择的商品在同层已经存在，是否继续添加？")
            .then(res => {
              this.$set(this.formData.items_list, _index, _item);
            });
        } else if (eqList.length > 0 && this.mode === "GR") {
          this.$message({
            type: "error",
            message: "同层已存在相同商品"
          });
        }
        //如果是重力柜子，并且同层商品不重复
        if (this.mode === "GR" && eqList.length === 0) {
          if (GRlist.length > 0) {
            this.validateGravity(_index, _item, GRlist);
          } else {
            this.$set(this.formData.items_list, _index, _item);
          }
        } else if (eqList.length === 0) {
          this.$set(this.formData.items_list, _index, _item);
        }
      }
      this.selectGoodsVisible = false;
    },
    validateGravity(_index, _item, GRlist) {
      this.$axios
        .post(apis.template_check, {
          add_item: {
            item_id: _item.item_id,
            qty: _item.qty
          },
          item_list: GRlist
        })
        .then(res => {
          let { code, data, msg } = res.data;
          if (code === 201) {
            this.$message({
              type: "error",
              message: msg
            });
            _item.qty = data.qty;
            _item.max_qty = data.qty;
            this.$set(this.formData.items_list, _index, _item);
          } else if (code === 200) {
            this.$set(this.formData.items_list, _index, _item);
          } else {
            this.$message({
              type: "error",
              message: msg
            });
          }
        });
    },
    add() {
      let _this = this;
      this.submit(function() {
        _this.$router.push({
          name: "shoppingModel"
        });
      });
    },
    addNext() {
      let _this = this;
      this.submit(function() {
        _this.$message({
          type: "success",
          message: "添加成功"
        });
        _this.formData = {
          items_list: []
        };
      });
    },
    submit(fn) {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.formData.items_list.forEach((item, index) => {
            this.validateQty(item, index);
            this.validatePrice(item, index);
          });
          let _formData = deepClone(this.formData);
          //存储数据更改
          _formData.items_list.forEach((item, index) => {
            if (item.qty_error || item.price_error) {
              err = true;
              return;
            }
            //将价格变为分
            item.cost_price = item.cost_price * 100;
            item.real_price = item.real_price * 100;
          });
          //将无用的货柜编号删除
          _formData.items_list = _formData.items_list.filter(item => {
            return item.item_id !== "";
          });
          let errRow = [];
          for (let i = 1; i <= this.maxRow; i++) {
            let rowsLen = this.formData.items_list.filter(item => {
              return item.rows === i;
            }).length;
            if (rowsLen === 0) {
              errRow.push(i);
            }
          }
          if (_formData.items_list.length === 0) {
            this.$message({
              type: "error",
              message: "请至少选择一种商品"
            });
          } else if (errRow.length > 0) {
            alert
              .alert(
                "第" + errRow.join(",") + "层货道没有一种商品，是否继续保存？"
              )
              .then(res => {
                this.submitData(_formData);
              });
          } else {
            this.submitData(_formData, fn);
          }
        }
      });
    },
    submitData(_formData, fn) {
      if (this.$route.query.id) {
        this.$axios
          .post(apis.template_update, _formData)
          .then(res => {
            if (res.data.code === 200) {
              fn();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          })
          .catch(err => {
            this.$message({
              type: "error",
              message: err.data.msg
            });
          });
      } else {
        this.$axios
          .post(apis.template_add, _formData)
          .then(res => {
            if (res.data.code === 200) {
              fn();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          })
          .catch(err => {
            this.$message({
              type: "error",
              message: err.data.msg
            });
          });
      }
    },
    reset() {
      this.terminal_type_id = "";
      this.formData.terminal_rows = "";
      this.formData.terminal_column = "";
      this.$refs["form"].resetFields();
    },
    goBack() {
      this.$router.push({
        name: "shoppingModel"
      });
    },
    validatePrice(item, index) {
      if (!item.cost_price || !item.real_price) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "成本和售价必须填写"
        );
      } else if (
        !validate_decimal(item.cost_price) ||
        !validate_decimal(item.real_price)
      ) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "成本和售价必须填写数字"
        );
      } else if (+item.cost_price < 0.01) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "成本必须大于0.01"
        );
      } else if (+item.real_price < 0.01) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "售价必须大于0.01"
        );
      } else if (+item.cost_price > +item.real_price) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "成本必须小于售价"
        );
      } else {
        this.$set(this.formData.items_list[index], "price_error", "");
        //修改价格中保持所有同商品相同价格
        this.formData.items_list.forEach((_item, _index) => {
          if (_item.item_id === item.item_id && index !== _index) {
            _item.cost_price = item.cost_price;
            _item.real_price = item.real_price;
          }
        });
      }
    },
    validateQty(item, index) {
      if (!item.qty || !item.warn_qty) {
        this.$set(
          this.formData.items_list[index],
          "qty_error",
          "可放数量和预警数量必须填写"
        );
      } else if (!isNumber(item.qty) || !isNumber(item.warn_qty)) {
        this.$set(
          this.formData.items_list[index],
          "qty_error",
          "可放数量和预警数量必须填数字"
        );
      } else if (+item.qty > 10) {
        this.$set(
          this.formData.items_list[index],
          "qty_error",
          "可放数量不能大于10"
        );
      } else if (item.max_qty && +item.qty > +item.max_qty) {
        this.$set(this.formData.items_list[index], "qty", item.max_qty);
      } else if (+item.qty < +item.warn_qty) {
        this.$set(
          this.formData.items_list[index],
          "qty_error",
          "可放数量必须大于预警数量"
        );
      } else {
        this.$set(this.formData.items_list[index], "qty_error", "");
      }
      if (this.mode === "GR") {
        //拿出同层商品
        let GRlist = [];
        this.formData.items_list.forEach(_item => {
          if (_item.rows === item.rows && _item.item_id) {
            GRlist.push(_item);
          }
        });
        if (item.item_id) {
          this.validateGravity(index, item, GRlist);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-con__header {
  padding: 15px;
}

.table-con__header-title {
  font-weight: bold;
  color: #1ab394;
}

.table-con__count {
  padding: 10px;
  font-size: 12px;
  color: #666;
}

.table-con__footer {
  margin-top: 15px;
  text-align: center;
}

.table-con__header-operate {
  margin-top: 15px;
}

.table-error {
  position: absolute;
  color: #f56c6c;
  font-size: 12px;
  width: 90px;
  top: 72px;
  text-align: left;
  left: 32px;
  line-height: 16px;
}

.submit-container {
  margin-top: 20px;
}

.table-con__input {
  width: 80px;
}

.dialog-tip {
  font-size: 12px;
  color: red;
}
</style>
